import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "letter-spacing"
    }}>{`letter-spacing`}</h1>
    <p><strong parentName="p">{`Since`}</strong>{` UXP v2.0`}</p>
    <p>{`Sets the width inserted between letters.`}</p>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en/docs/Web/CSS/letter-spacing"
      }}>{`https://developer.mozilla.org/en/docs/Web/CSS/letter-spacing`}</a></p>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-css"
      }}>{`.someElement {
    letter-spacing: 3px;
}
`}</code></pre>
    <h2 {...{
      "id": "quirks-and-exceptions"
    }}>{`Quirks and Exceptions`}</h2>
    <ul>
      <li parentName="ul">{`Negative values are not valid, and will result in the letters printing on top of each other.`}</li>
      <li parentName="ul">{`Not all Spectrum UXP components support overriding the letter spacing.`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      